<div class="card shadow p-3 mb-5 bg-white rounded">
    
    <div *ngIf="Nombre">
        <h1>{{Nombre}}</h1>
        <p [innerHTML]="Descripcion"></p>
    </div>

    <div id="surveyContainer">
        <div id="surveyElement"></div>
    </div>

</div>